import { ScrollText, FileText, User, PenTool, CreditCard, CheckCircle, Shield, Users, Zap } from 'lucide-react';

export const API = process.env.REACT_APP_BACKEND_URL + '/api';

// URLs des documents officiels FTPE avec filigrane CONSULTATION
export const FTPE_DOCUMENTS = {
  statuts: `${process.env.REACT_APP_BACKEND_URL}/api/ftpe-adhesion/documents/watermarked/statuts`,
  reglement: `${process.env.REACT_APP_BACKEND_URL}/api/ftpe-adhesion/documents/watermarked/reglement`,
  charte: `${process.env.REACT_APP_BACKEND_URL}/api/ftpe-adhesion/documents/watermarked/charte`
};

// URLs des documents officiels FTPE pour téléchargement (sans filigrane)
export const FTPE_DOCUMENTS_DOWNLOAD = {
  statuts: `${process.env.REACT_APP_BACKEND_URL}/api/ftpe-adhesion/documents/download/statuts`,
  reglement: `${process.env.REACT_APP_BACKEND_URL}/api/ftpe-adhesion/documents/download/reglement`,
  charte: `${process.env.REACT_APP_BACKEND_URL}/api/ftpe-adhesion/documents/download/charte`
};

// Configuration du workflow - 6 étapes
export const WORKFLOW_STEPS = [
  { id: 1, name: 'Document Maître', icon: ScrollText, description: 'Cadre juridique' },
  { id: 2, name: 'Présentation', icon: FileText, description: 'Découvrez les avantages' },
  { id: 3, name: 'Informations', icon: User, description: 'Renseignez votre entreprise' },
  { id: 4, name: 'Signature', icon: PenTool, description: 'Signez électroniquement' },
  { id: 5, name: 'Paiement', icon: CreditCard, description: 'Réglez votre cotisation' },
  { id: 6, name: 'Confirmation', icon: CheckCircle, description: 'Adhésion validée' }
];

export const PLAN_FEATURES = [
  { icon: Shield, text: 'Représentation patronale' },
  { icon: Users, text: 'Accès aux services et informations FTPE' },
  { icon: Zap, text: 'Participation à la vie syndicale' },
  { icon: FileText, text: 'Accès aux dispositifs solidaires COPPAM' }
];

export const TYPE_ADHESION_OPTIONS = [
  { value: 'tpe', label: 'Adhésion TPE' },
  { value: 'independant', label: 'Adhésion Entrepreneur individuel / Indépendant' },
  { value: 'createur', label: 'Adhésion Créateur / Porteur de projet' },
  { value: 'partenaire', label: 'Adhésion Partenaire / Structure d\'accompagnement' }
];
